export default {
  name: 'nombre',
  lastname: 'apellido',
  email: 'email',
  price: 'precio',
  password: 'contraseña',
  catalogue: 'catálogo',
  phone: 'teléfono',
  image: 'imagen',
  months: 'meses',
  message: 'mensaje',
  password_confirmation: 'confirmar contraseña',
  storeName: 'nombre de la tienda',
  storeBotName: 'nombre del bot de la tienda',
  storeDescription: 'descripción de la tienda',
  storeCategory: 'categoria de la tienda',
  telegramBotToken: 'token del bot de telegram',
  description: 'descripción',
  bank_name: 'nombre del banco',
  account_type: 'tipo de cuenta',
  account_number: 'número de cuenta',
  owner_full_name: 'nombre del titular',
  owner_idenfication_type: 'tipo de documento',
  owner_idenfication: 'documento del titular',
  dollarPercentage: 'porcentaje del dolar',
  dollarRate: 'tasa del dolar',
  cancellationReason: 'motivo de cancelación'
}